class Dropdown {
  /*
  * constructor
  */
  constructor() {
    this.element = document.querySelector('.c-faqBlock__blocksWrapper');

    if (_.isNull(this.element) === false) {
      this.resize();
    }
  }

  resize() {
    const btn = this.element.querySelector('.c-faqBlock__btn');
    const dropdown = this.element.querySelector('.c-faqBlock__menu');
    const height = dropdown.scrollHeight;

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.element.classList.contains('c-faqBlock__blocksWrapper--is-open')) {
        this.element.classList.remove('c-faqBlock__blocksWrapper--is-open');
        dropdown.style.removeProperty('max-height', '0px');
      } else {
        this.element.classList.add('c-faqBlock__blocksWrapper--is-open');
        dropdown.style.maxHeight = `${height}px`;
      }
    });
  }
}

module.exports = Dropdown;